import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as vibeFilesActions from '../actions/vibe-files.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {BuilderV2Service} from "../../builder-v2/builder-v2.service";
import {LoadVibeFiles} from "../actions";

@Injectable()
export class VibeFilesEffects {

  constructor(
    private _actions$: Actions,
    private _builderV2Service: BuilderV2Service
  ) {
  }

  loadVibeFiles$ = createEffect(() => this._actions$.pipe(
    ofType(vibeFilesActions.LOAD_VIBE_FILES),
    mergeMap((action: LoadVibeFiles) => {
      const domainId = action.payload.domainId;
      return this._builderV2Service.getVibeCodingFiles(domainId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new vibeFilesActions.LoadVibeFilesSuccess({domainId, data: response.data});
            }
            return new vibeFilesActions.LoadVibeFilesFail({domainId, error: response.message});
          })
        );
    })
  ));
}
